import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { smoothScrollTo } from "./shared";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-[76px] flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => smoothScrollTo("hero")}
          className="flex items-center gap-3 group"
        >
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full border border-[#d4af37]">
            <span className="absolute h-2 w-2 rounded-full bg-[#d4af37] transition-transform duration-500 group-hover:scale-150" />
          </span>
          <span className="font-display text-white text-sm sm:text-base font-800 font-bold tracking-[0.2em] uppercase">
            XXX Video Casting
          </span>
        </button>

        <nav className="flex items-center gap-8">
          <button
            data-testid="nav-home"
            onClick={() => smoothScrollTo("hero")}
            className="hidden sm:inline text-[#cccccc] text-sm tracking-widest uppercase hover:text-white transition-colors duration-300"
          >
            Home
          </button>
          <button
            data-testid="nav-apply"
            onClick={() => smoothScrollTo("apply")}
            className="font-display text-xs sm:text-sm font-bold tracking-[0.2em] uppercase bg-[#d4af37] text-black px-5 py-2.5 hover:bg-[#e5a93b] transition-all duration-300 hover:scale-[1.03] active:scale-95"
          >
            Apply Now
          </button>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
